import {
  ArrowRight,
  BellSimple,
  Numpad,
  Question,
  ScanSmiley,
  SignOut,
  Warning,
  WarningCircle,
} from "@phosphor-icons/react";
import { googleLogout } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Gambar } from "./assets/svg/happy_news.svg";
import HReport from "./component/HReport";
import HAnnouncement from "./component/HAnnouncement";
import axios from "axios";
import { toast } from "sonner";

const Settings = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [cookies, removeCookie] = useCookies(["token"]);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [id_user, setIdUser] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const onClose = () => {
    setIsVisible(false);
    setIsVisible2(false);
  };
  const navigate = useNavigate();

  const toggleSwitch = () => {
    setIsChecked(!isChecked);
  };

  // Menggunakan useEffect untuk navigasi
  useEffect(() => {
    if (!cookies.token) {
      navigate("/login");
    } else {
      const handleUser = async() => {
        try {
          const token = cookies.token;
          if (typeof token === "string" && token) {
            const dataUser = jwtDecode(token);
            const emaill = dataUser.email
            const api = `${process.env.REACT_APP_SERVER}/api/user/${emaill}`
            const data = await axios.get(api)
            const id_usr  = data.data.payload.datas.id

            setIdUser(id_usr)
            setIsLoading(false)
            
          } else {
            throw new Error("Invalid token format");
          }
        } catch (error) {
          console.error("Invalid token", error);
          navigate("/login");
        }
      }
      handleUser()
    }
  }, [cookies.token, navigate]);

  const handleLogout = () => {
    googleLogout(); // Pastikan ini didefinisikan
    removeCookie("token"); // Hapus cookie
    navigate("/login"); // Redirect ke login
  };

  // Mendapatkan data pengguna setelah validasi token
  let nameUser = "";
  let emailUser = "";
  let imageUser = "";

  if (cookies.token) {
    try {
      const dataUser = jwtDecode(cookies.token);
      nameUser = dataUser.name || "";
      emailUser = dataUser.email || "";
      imageUser = dataUser.picture || "";
    } catch (error) {
      console.error("Failed to decode user data", error);
    }
  }

  if(isLoading) return <></>

  return (
    <div className="relative min-h-svh bg-slate-100 flex flex-col gap-4 px-4 pt-4 pb-20">
      <div className="flex flex-col gap-3 items-center py-4">
        <ImageComponent src={imageUser} alt={nameUser} />
        <div className="flex gap-1 flex-col items-center">
          <p className="font-bold text-lg">{nameUser}</p>
          <p className="font-semibold text-sm text-gray-400">{emailUser}</p>
        </div>
        <div className="flex justify-center">
          <Link
            to={"/edit-profile"}
            className="cursor-pointer px-4 py-2 text-md rounded-full text-white bg-green-700 shadow-lg"
          >
            Edit Profile
          </Link>
        </div>
      </div>
      {/* <div className="flex gap-2 flex-col">
        <p className="text-sm text-gray-400 font-semibold">Iventories</p>
        <div className="flex flex-col px-3 rounded-xl border border-gray-400 bg-gray-200">
          <div className="flex items-center h-full justify-between py-2 gap-3 border-b border-gray-400">
            <div className="flex justify-center items-center bg-slate-100 w-10 h-10 shadow rounded-md"></div>
            <div className="flex gap-2 items-center flex-1 ">
              <p className="text-md font-semibold">My Stores</p>
              <div className="font-semibold bg-green-700 rounded-full text-white w-5 aspect-square text-center text-xs">
                2
              </div>
            </div>
            <ArrowRight size={32} className="text-gray-400" />
          </div>
          <div className="flex items-center h-full justify-between py-2 gap-3">
            <div className="flex justify-center items-center bg-slate-100 w-10 h-10 shadow rounded-md"></div>
            <div className="flex gap-2 items-center flex-1">
              <p className="text-md font-semibold">Support</p>
            </div>
            <ArrowRight size={32} className="text-gray-400" />
          </div>
        </div>
      </div> */}
      <div className="w-full h-32 flex items-center px-6 gap-2  justify-evenly shadow-lg rounded-lg bg-gray-200">
        <Gambar height={100} width={100} />
        <div className=" max-w-52">
          <p className="text-sm">
            "Kalian tim editor semangat ya, Editor pekerjaanku Bersuka ria
            kesenaganku"
          </p>
          <p className="text-end text-xs mt-1 pe-4">-anonym</p>
        </div>
      </div>
      <div className="flex gap-2 flex-col">
        <p className="text-sm text-gray-400 font-semibold">Preferences</p>
        <div className="flex flex-col px-3 rounded-xl border border-gray-400 bg-gray-200">
          {/* <div className="flex items-center h-full justify-between py-2 gap-3 border-b border-gray-400">
            <div className="flex justify-center items-center bg-slate-100 w-10 h-10 shadow rounded-md">
              <BellSimple size={20} />
            </div>
            <div className="flex gap-2 items-center flex-1 ">
              <p className="text-md font-semibold">Push Notifications</p>
              <div className="font-semibold bg-green-700 rounded-full text-white w-5 aspect-square text-center text-xs">
                2
              </div>
            </div>
            <label className="flex items-center cursor-pointer">
              <div className="relative">
                <input
                  type="checkbox"
                  className="sr-only"
                  checked={isChecked}
                  onChange={toggleSwitch}
                />
                <div
                  className={`block w-14 h-8 rounded-full ${
                    isChecked ? "bg-green-700" : "bg-gray-400"
                  } transition-colors duration-300 ease-in-out`}
                ></div>
                <div
                  className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform duration-300 ease-in-out ${
                    isChecked ? "transform translate-x-full" : ""
                  }`}
                ></div>
              </div>
            </label>
          </div> */}
          {/* <div className="flex items-center h-full justify-between py-2 gap-3 border-b border-gray-400">
            <div className="flex justify-center items-center bg-slate-100 w-10 h-10 shadow rounded-md">
              <ScanSmiley size={20} />
            </div>
            <div className="flex gap-2 items-center flex-1">
              <p className="text-md font-semibold">Face ID</p>
            </div>
            <label className="flex items-center cursor-pointer">
              <div className="relative">
                <input
                  type="checkbox"
                  className="sr-only"
                  checked={isChecked}
                  onChange={toggleSwitch}
                />
                <div
                  className={`block w-14 h-8 rounded-full ${
                    isChecked ? "bg-green-700" : "bg-gray-400"
                  } transition-colors duration-300 ease-in-out`}
                ></div>
                <div
                  className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform duration-300 ease-in-out ${
                    isChecked ? "transform translate-x-full" : ""
                  }`}
                ></div>
              </div>
            </label>
          </div> */}
          {/* <div className="flex items-center h-full justify-between py-2 gap-3 border-b border-gray-400">
            <div className="flex justify-center items-center bg-slate-100 w-10 h-10 shadow rounded-md">
              <Numpad size={20} />
            </div>
            <div className="flex gap-2 items-center flex-1">
              <p className="text-md font-semibold">PIN Code</p>
            </div>
            <ArrowRight size={32} className="text-gray-400" />
          </div> */}
          <div
            onClick={() => setIsVisible2(true)}
            className="flex cursor-pointer text-amber-800 items-center justify-between py-2 gap-3"
          >
            <div className="flex justify-center items-center bg-amber-100 w-10 h-10 shadow rounded-md">
              <Warning size={20} />
            </div>
            <div className="flex gap-2 items-center flex-1">
              <p className="text-md font-semibold">Announcement</p>
            </div>
          </div>
          <HAnnouncement id_user={id_user} isVisible={isVisible2} onClose={onClose} />

          <div
            onClick={() => setIsVisible(true)}
            className="flex cursor-pointer text-red-800 items-center justify-between py-2 gap-3"
          >
            <div className="flex justify-center items-center bg-red-100 w-10 h-10 shadow rounded-md">
              <WarningCircle size={20} />
            </div>
            <div className="flex gap-2 items-center flex-1">
              <p className="text-md font-semibold">Report</p>
            </div>
          </div>
          <HReport id_user={id_user} isVisible={isVisible} onClose={onClose} />

          <div className="flex items-center h-full justify-between py-2 gap-3">
            <div className="flex justify-center items-center bg-slate-100 w-10 h-10 shadow rounded-md">
              <Question size={20} />
            </div>
            <div className="flex gap-2 items-center flex-1">
              <a
                href={
                  "https://wa.me/628382510268?text=Kak%20kamu%20mau%20nanya%20nih,%20seputar%20Web%20absen%20dhohho%20tv!"
                }
                className="text-md cursor-pointer font-semibold"
              >
                Support
              </a>
            </div>
            {/* <ArrowRight size={32} className="text-gray-400" /> */}
          </div>

          <div
            onClick={handleLogout}
            className="flex cursor-pointer text-red-800 items-center justify-between py-2 gap-3"
          >
            <div className="flex justify-center items-center bg-red-100 w-10 h-10 shadow rounded-md">
              <SignOut size={20} />
            </div>
            <div className="flex gap-2 items-center flex-1">
              <p className="text-md font-semibold">Logout</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;

const ImageComponent = ({ src, alt }) => {
  const handleError = (event) => {
    // Mengubah sumber gambar ke gambar default jika terjadi error
    event.target.src = "./undraw_male-avatar_zkzx.png";
  };

  return (
    <img
      src={src}
      alt={alt}
      className=" object-cover bg-gray-300 rounded-full w-24 aspect-square"
      onError={handleError} // Menangani error saat gambar tidak ter-load
    />
  );
};
